import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { useAuthorization } from '$/components/core/Authentication/hooks/useAuthorization';
import { AuthActionCard } from '$/components/core/Projects/components/Cards/AuthActionCard';
import { DashboardSection } from '$/pages/DashboardPages/components/DashboardSection';
import { DashboardSectionRow } from '$/pages/DashboardPages/components/DashboardSectionRow';
import { ProjectRowItems } from '$/pages/DashboardPages/pages/Welcome/components/ProjectSection/components/ProjectRowItems';
import { projectsQuery } from '$/services/usecases/projects/queries';

export const ProjectSection = () => {
  const { t } = useTranslation();

  const { getProjectCountLimit, hasPermission } = useAuthorization();

  const projectCount = useQuery(projectsQuery).data?.projectCount ?? 0;

  const getHeadline = () => {
    if (hasPermission('General_Project_Page')) {
      if (hasPermission('General_Welcome_Project_Count')) {
        return t('dashboard.welcome.lastUsedCount', {
          userProjectCount: projectCount,
          projectCountLimit: getProjectCountLimit(),
        });
      }
      return t('dashboard.welcome.lastUsed');
    }

    if (hasPermission('General_Welcome_Project_Count')) {
      return t('dashboard.welcome.ownProjectCount', {
        userProjectCount: projectCount,
        projectCountLimit: getProjectCountLimit(),
      });
    }
    return t('dashboard.welcome.ownProjectPic');
  };

  const additionalProperties = hasPermission('General_Project_Page')
    ? { showAllUrl: '/projects' as const }
    : {};

  return (
    <DashboardSection headline={getHeadline()} {...additionalProperties}>
      <DashboardSectionRow>
        {hasPermission('Project_Open') ? (
          <ProjectRowItems />
        ) : (
          <AuthActionCard />
        )}
      </DashboardSectionRow>
    </DashboardSection>
  );
};
